module.exports = __webpack_public_path__ + "img/album10_13.e12d40a3.jpg";